import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router';
import get from 'lodash/get';
import classNames from 'classnames';

import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import { Book } from 'rebook/apps/books/models';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as BookDetailActions from 'rebook/apps/books/actions/BookDetailActions';
import BookPayment from 'rebook/apps/books/components/BookPayment';
import BookRentHeader from 'rebook/apps/books/components/BookRentHeader';
import BookRentAppButtons from 'rebook/apps/books/components/BookRentAppButtons';

import styles from './style.scss';


class BookPaymentsView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(SeoActions.setData({
      robots: 'noindex',
    }));
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { match, location } = this.props;
    this.props.BookDetailActions.fetchInitialData(match, location);
  }

  componentWillReceiveProps({ match, location }) {
    const currentBookSlug = this.props.match.params.bookSlug;
    const newBookSlug = match.params.bookSlug;
    if (newBookSlug && newBookSlug !== currentBookSlug) {
      this.props.BookDetailActions.resetData();
      this.props.BookDetailActions.fetchInitialData(match, location);
    }
  }

  componentWillUnmount() {
    this.props.SeoActions.resetData();
  }

  handleClick(type) {
    const { book } = this.props.bookDetail;
    const buttonType = type === 'subscription'
      ? 'GoToSubscription'
      : 'GoToRent';
    ga('send', 'event', {
      eventCategory: 'Payment',
      eventAction: 'PushPurchase',
      eventLabel: book.name,
    });
    ga('send', 'event', {
      eventCategory: 'Payment',
      eventAction: 'PushButton',
      eventLabel: buttonType,
    });
  }

  getPaymentBlocks({ absoluteUrl, subscriptionId, userPrice, rentPrice, daysPeriod, user }) {
    return (
      <React.Fragment>
        <BookPayment bookLink={absoluteUrl}
          handleClick={(type) => {
            this.handleClick(type);
          }}
          price={userPrice}
          type="subscription"
          subscriptionId={subscriptionId}
          user={user} />
        <BookPayment bookLink={absoluteUrl}
          handleClick={(type) => {
            this.handleClick(type);
          }}
          price={rentPrice}
          daysPeriod={daysPeriod}
          type="rent"
          user={user} />
      </React.Fragment>
    );
  }

  render() {
    const { bookDetail, user } = this.props;
    const { book } = bookDetail;
    const theBook = new Book(book);
    const subscriptionId = get(theBook, 'subscription_id', '');
    const isAudioBook = get(theBook, 'type', '') === 'audio';
    const isAvailable = !!get(theBook, 'available', false);
    const absoluteUrl = get(book, 'absolute_url', '');

    if (book && (!subscriptionId || !get(theBook, 'rent_product.is_active', false) || !isAvailable)) {
      return <Redirect to={book.absolute_url} />;
    }


    const userPrice = get(theBook, 'web_subscription_full_price', 0);
    const rentPrice = parseInt(get(book, 'rent_product.web_price', 0));
    const daysPeriod = get(theBook, 'rent_product.days', null);

    const paymentBlocksInfo = {
      absoluteUrl,
      subscriptionId,
      userPrice,
      rentPrice,
      daysPeriod,
      user,
    };

    return (
      <div className={classNames(styles.bookPayments)}>
        {!book && <SpinnerLoader />}
        {book && (
          <React.Fragment>
            <BookRentHeader book={theBook} />
            <div className={classNames(styles.bookPaymentTypesContainer, 'jest-book-payments-type-blocks')}>
              {book && (
                this.getPaymentBlocks(paymentBlocksInfo)
              )}
            </div>
            <div className={classNames(
              styles.bookPaymentTypesSliderContainer,
              'jest-book-payments-type-blocks-mobile')}>
              {book && (
                <ContentCarousel>
                  {this.getPaymentBlocks(paymentBlocksInfo)}
                </ContentCarousel>
              )}
            </div>
            <BookRentAppButtons isAudio={isAudioBook} />
          </React.Fragment>
        )}
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    payments: state.payments,
    bookDetail: state.bookDetail,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    BookDetailActions: bindActionCreators(BookDetailActions, dispatch),
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BookPaymentsView);
